import { Flex, xcss } from '@atlaskit/primitives';

const style = xcss({
  height: '100vh',
});

const Loading = () => (
  <Flex xcss={style} alignItems="center" justifyContent="center">
    {/*Commented out for the time being due to MARIO-6496*/}
    {/*<Spinner />*/}
    <div />
  </Flex>
);

export default Loading;
